<template>
	<div>
		<c-dialog ref="dialog" title="免费续期" width="600" height="310" button-name="确定续期1年" @resolve="resolve">
			<div class="info">
				<p>
					<label>系统版本：</label>
					<span><b>蜂鸟工单【免费版】</b></span>
				</p>
				<p>
					<label>工厂代码：</label>
					<span>{{saasInfo.saas_id}}</span>
				</p>
				<p>
					<label>工厂名称：</label>
					<span>{{saasInfo.saas_name}}</span>
				</p>
				<p>
					<label>员工账号：</label>
					<span>{{saasInfo.max_account_count}}</span>
				</p>
				<p>
					<label>到期时间：</label>
					<span>{{saasInfo.auth_exp_date}}</span>
				</p>
			</div>
			<c-checkbox v-model="agreement" class="agreement-check">我已阅读并同意<c-link color="main" @click.native.stop="$refs.agreement.open()">《蜂鸟工单软件服务条款》</c-link></c-checkbox>
		</c-dialog>

		<c-dialog ref="agreement" width="750" height="500" title="蜂鸟工单软件服务条款" button-name="同意以上协议" :cancel-button="false" @resolve="agreement = true">
			<div v-if="systemConfig" v-html="systemConfig.free_regist_agreement" class="agreement"></div>
		</c-dialog>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				agreement: false
			}
		},

		computed: {
			...mapState(['systemConfig', 'saasInfo'])
		},

		methods: {
			open() {
				this.$refs.dialog.open();
			},

			resolve(stop, next) {
				stop();
				if (!this.agreement) {
					this.$message({
						message: '请阅读并同意《蜂鸟工单软件服务条款》'
					});
					return;
				}
				
				this.request({
					url: '/sys_saas/free/renewal',
					loading: true,
					success: () => {
						next();
						this.$message({
							message: '续期成功'
						});
						this.$store.dispatch('updateLoginInfo');
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.info {
		border-radius: 6px;
		padding: 14px 24px;
		margin: 18px 20px;
		background: #F9F9F9;

		p {
			line-height: 36px;
			font-size: 14px;

			label {
				color: #666;
			}
		}
	}

	.agreement {
		padding: 20px 30px;
		line-height: 2;
		font-size: 14px;
		color: #333;

		&-check {
			margin-left: 24px;
		}
	}
</style>
